import { z } from 'zod';

/**
 * Schema factory for creator VAT / tax transaction details.
 * Add more fields here later if the VAT flow is expanded.
 */
export const createVatNumberSchema = () =>
  z.object({
    vat_country: z.string().min(1, 'Country is required'),
    vat_number: z
      .string()
      .min(1, 'VAT number is required')
      .max(50, 'VAT number is too long'),
  });

/**
 * Schema for GST number form. Country is required; GST number is optional (user may submit blank).
 */
export const createGstNumberSchema = () =>
  z.object({
    country: z.string().min(1, 'Country is required'),
    gst_number: z.string().max(50, 'GST number is too long'),
  });

/**
 * Creates a dynamic Zod schema based on masspay attributes
 * Only includes required (non-optional) fields to match what's rendered in the form
 * @param {Array} attributes - Array of attribute objects from masspay API
 * @returns {z.ZodObject} Zod schema object for form validation
 */
export const createDynamicSchemaForBankAccount = (attributes = []) => {
  const schemaObject = {};

  // Only create schema for required fields (matching DynamicMasspayForm behavior)
  const requiredAttributes = attributes.filter((attr) => !attr.is_optional);

  requiredAttributes.forEach((attr) => {
    const { token, validation, label, expected_value } = attr;
    let fieldSchema = z.string();

    // Apply validation regex if provided
    if (validation) {
      try {
        const regex = new RegExp(validation);
        fieldSchema = fieldSchema.regex(regex, {
          message: expected_value || `${label} format is invalid`
        });
      } catch (error) {
        // If regex is invalid, fall back to basic string validation
        // Silently continue with default validation
      }
    }

    // All fields in this schema are required (non-optional)
    fieldSchema = fieldSchema.min(1, `${label} is required`);

    schemaObject[token] = fieldSchema;
  });

  return z.object(schemaObject);
};

